import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { Prescription } from "@customTypes/prescription";

import { prescriptionQKeys } from "./queryKeys";


const select = (res: any) => {
  // console.log(res.data);

  if (Object.keys(res.data).length) {
    const newData = {} as Prescription;

    const {
      _id,
      prescribed_by,
      prescription_date,
      consultation_id,
      consultation_info,
      fast_consultation,
      files,
      created_at,
      updated_at,
    } = res.data;

    newData.id = _id;
    newData.consultationId = consultation_id;
    newData.consultationInfo = {
      cId: consultation_info?.c_id,
      physician: {
        id: consultation_info?.physician?._id,
        fullName: consultation_info?.physician?.full_name,
      },
      date: new Date(consultation_info?.date),
    };
    newData.prescriptionDate = new Date(prescription_date);
    newData.date = new Date(prescription_date);
    newData.files = files;
    newData.prescribedBy = {
      id: prescribed_by?._id,
      fullName: prescribed_by?.full_name,
    };
    newData.createdAt = new Date(created_at);
    newData.updatedAt = new Date(updated_at);
    newData.isFastConsultation = fast_consultation;

    // console.log(newData);
    return newData;
  }
  return null;
};

interface QueryProps {
  prescriptionId: string;
  isEnabled?: boolean;
}

export const useGetSinglePrescription = ({
  prescriptionId,
  isEnabled = true,
}: QueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: prescriptionQKeys.singlePrescription(prescriptionId),
    queryFn: () => {
      return api.get(`prescription/${prescriptionId}`);
    },
    select,
    enabled: isEnabled,

    onError: (res: any) => {
      console.error("[From Get Prescription By Prescription id]", res);
      handleErrors(res, "query");
    },
  });
};
